export function getJsonFormPayload(packages: any, selectedPackage: any) {
  const selectedPackageDetails = packages?.find(
    ({ id }: any) => id === selectedPackage
  );

  if (!selectedPackageDetails || !selectedPackageDetails.check_details) {
    return {};
  }

  return Object.fromEntries(
    selectedPackageDetails.check_details.map((check: any) => [
      check.check_type,
      check.check_arguments || {},
    ])
  );
}
